import {NgModule} from "@angular/core";
import {MatDividerModule} from "@angular/material/divider";
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {TranslateModule} from '@ngx-translate/core';
import {PreviewAlerteModule} from "@share/component/alerte/preview-alerte.module";
import {LoginService} from "@share/login/login.service";
import {ShareModule} from "@share/share.module";
import {ProfilService} from "../../../profil/profil.service";
import {MatLegacyRadioModule as MatRadioModule} from "@angular/material/legacy-radio";
import {DroitAdmin} from "@core/security/droit-admin";
import {FacturesRelevesComponent} from "./releves/factures-releves.component";
import {FacturesFournisseursComponent} from "./fournisseurs/factures-fournisseurs.component";
import {FacturesTypesChargesComponent} from "./types-charges/factures-types-charges.component";
import {FacturesTypesChargesItemComponent} from "./types-charges/types-charges-item/factures-types-charges-item.component";
import {FacturesTolerancesComponent} from "./tolerances/factures-tolerances.component";
import {FraisFacturesComponent} from "./frais-factures.component";
import {ReleveFactureModule} from "@components/facture/releve-facture.module";
import {FraisFacturesService} from "@components/admin/frais/factures/frais-factures.service";
import {FacturesTypesChargesInfosComponent} from "./types-charges/types-charges-infos/factures-types-charges-infos.component";
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatLegacyDialogModule} from '@angular/material/legacy-dialog';
import {FacturesTypesChargesInfosIconesComponent} from "./types-charges/types-charges-infos/factures-types-charges-infos-icones.component";
import {TypesChargesService} from "@services/admin/facture/types-charges.service";
import {FormsModule} from "@angular/forms";
import {CustomInputModule} from "@share/component/custom-input/custom-input.module";
import {ModifyTolerancesPopinComponent} from "./tolerances/modify-tolerances-popin/modify-tolerances-popin.component";
import {FacturesTolerancesItemComponent} from "./tolerances/tolerances-item/factures-tolerances-item.component";
import {FacturesToleranceService} from "./tolerances/factures-tolerance.service";
import {FacturesFournisseursItemComponent} from "./fournisseurs/fournisseurs-item/factures-fournisseurs-item.component";
import {FacturesFournisseursInfosComponent} from "./fournisseurs/fournisseurs-infos/factures-fournisseurs-infos.component";
import {FournisseursService} from "@services/admin/facture/fournisseurs.service";
import {LieuModule} from "@components/lieu/lieu.module";
import {FacturesFournisseursContratComponent} from './fournisseurs/fournisseurs-contrat/factures-fournisseurs-contrat.component';
import {FacturesFournisseursContratItemComponent} from './fournisseurs/fournisseurs-contrat/factures-fournisseurs-contrat-item.component';
import {FacturesFournisseursGeneralitesComponent} from './fournisseurs/fournisseurs-generalites/factures-fournisseurs-generalites.component';
import {ContratInfosComponent} from './contrat/contrat-infos/contrat-infos.component';
import {ContratGeneralitesComponent} from './contrat/contrat-generalites/contrat-generalites.component';
import {ContratComptesComponent} from './contrat/contrat-comptes/contrat-comptes.component';
import {ContratComptesItemComponent} from './contrat/contrat-comptes/contrat-comptes-item.component';
import {ContratCompteComponent} from './contrat/contrat-compte/contrat-compte.component';
import {ContratButtonService} from "@services/admin/contrat/contrat.button.service";
import {FournisseursTabsService} from "@services/admin/facture/fournisseurs.tabs.service";

export const fraisFacturesRoutes : Routes = [
    {
        path: 'Releves',
        component: FacturesRelevesComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_VISUALISATION_RELEVES_FACTURES] }
    }, {
        path: 'Fournisseurs/:id',
        component: FacturesFournisseursInfosComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_ENTREPRISE_FOURNISSEUR] },
        children: [
            {
                path: 'Generalites',
                component: FacturesFournisseursGeneralitesComponent,
                data: { sousAdminCredentials: [DroitAdmin.DROIT_ENTREPRISE_FOURNISSEUR] }
            },
            {
                path: 'Contrat',
                component: FacturesFournisseursContratComponent,
                data: { sousAdminCredentials: [DroitAdmin.DROIT_ENTREPRISE_FOURNISSEUR] }
            },
            {
                path: '',
                redirectTo: 'Generalites',
                pathMatch: 'full'
            }
        ]
    }, {
        path: 'Fournisseurs',
        component: FacturesFournisseursComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_ENTREPRISE_FOURNISSEUR] }
    }, {
        path: 'Contrat/:idContrat',
        component: ContratInfosComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_ENTREPRISE_FOURNISSEUR] },
        children: [
            {path: 'Generalites', component: ContratGeneralitesComponent, data: { sousAdminCredentials: [DroitAdmin.DROIT_ENTREPRISE_FOURNISSEUR] }},
            {path: 'Comptes', component: ContratComptesComponent, data: { sousAdminCredentials: [DroitAdmin.DROIT_ENTREPRISE_FOURNISSEUR] }},
            {path: 'Compte/:idCarte', component: ContratCompteComponent, data: { sousAdminCredentials: [DroitAdmin.DROIT_ENTREPRISE_FOURNISSEUR] }},
            {path: '', redirectTo: 'Generalites', pathMatch: 'full'}
        ]
    }, {
        path: 'TypesCharges',
        component: FacturesTypesChargesComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_INTERFACE_REF] }
    }, {
        path: 'TypesCharges/:idTypeCharge',
        component: FacturesTypesChargesInfosComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_INTERFACE_REF] }
    }, {
        path: 'Tolerances',
        component: FacturesTolerancesComponent,
        canActivate: [AdminGuardProvider],
        data: { sousAdminCredentials: [DroitAdmin.DROIT_GESTION_TOLERANCE] }
    }, {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Releves'
    }, {
        path: '**',
        redirectTo: 'Releves'
    }
];

@NgModule({
    imports: [
        ShareModule,
        PreviewAlerteModule,
        MatDividerModule,
        TranslateModule,
        MatRadioModule,
        ReleveFactureModule,
        MatInputModule,
        MatFormFieldModule,
        MatLegacyDialogModule,
        FormsModule,
        CustomInputModule,
        LieuModule
    ],
    declarations: [
        FraisFacturesComponent,
        FacturesRelevesComponent,
        FacturesFournisseursComponent,
        FacturesTypesChargesComponent,
        FacturesTolerancesComponent,
        FacturesTypesChargesItemComponent,
        FacturesTypesChargesInfosComponent,
        FacturesTypesChargesInfosIconesComponent,
        FacturesFournisseursItemComponent,
        FacturesFournisseursInfosComponent,
        ModifyTolerancesPopinComponent,
        FacturesTolerancesItemComponent,
        FacturesFournisseursContratComponent,
        FacturesFournisseursContratItemComponent,
        FacturesFournisseursGeneralitesComponent,
        ContratInfosComponent,
        ContratGeneralitesComponent,
        ContratComptesComponent,
        ContratComptesItemComponent,
        ContratCompteComponent
    ],
    exports: [
        FacturesRelevesComponent,
        FacturesFournisseursComponent,
        FacturesTypesChargesComponent,
        FacturesTolerancesComponent
    ],
    providers: [ProfilService,
        LoginService,
        FraisFacturesService,
        TypesChargesService,
        FacturesToleranceService,
        ContratButtonService,
        FournisseursTabsService,
        FournisseursService]
})
export class FraisFacturesModule {
}
